import { useMemo } from 'react'
import { withFloorplanStorey } from '@editor/utils'
import { useControlStore } from '@editorStores'
import useIsPlanView from './useIsPlanView'
import useVisibleModel from './useVisibleModel'

/**
 * The visible model as the floorplan draws it. In the Planansicht, elements with plan storeys are
 * placed on the previewed floorplan storey, so one shown on another plan storey is drawn and
 * labelled there, as in the exported plan.
 */
const useFloorplanModel = (): PlanarModel => {
  const storey = useControlStore(state => state.floorplanState.storey)
  const isPlanView = useIsPlanView()
  const visibleModel = useVisibleModel()

  return useMemo(() => {
    if (!isPlanView || !storey) return visibleModel
    return {
      ...visibleModel,
      walls: withFloorplanStorey(visibleModel.walls, storey),
      vertical_slabs: withFloorplanStorey(visibleModel.vertical_slabs, storey),
      beams: withFloorplanStorey(visibleModel.beams, storey),
      columns: withFloorplanStorey(visibleModel.columns, storey),
      rips: withFloorplanStorey(visibleModel.rips, storey),
      lintels: withFloorplanStorey(visibleModel.lintels, storey),
    }
  }, [isPlanView, storey, visibleModel])
}

export default useFloorplanModel
